import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, useTheme } from './context/ThemeContext';
import Header from './components/Header';
import HomePage from './pages/HomePage';
import ComingSoon from './pages/ComingSoon';
import TaskManager from './pages/TaskManager/TaskManager';
import ChatApp from './pages/ChatApp/ChatApp';
import Weather from './pages/Weather/Weather';
import Ecommerce from './pages/Ecommerce/Ecommerce';
import Analytics from './pages/Analytics/Analytics';
import SocialFeed from './pages/SocialFeed/SocialFeed';
import AIDashboard from './pages/AIDashboard/AIDashboard';
import RealEstate from './pages/RealEstate/RealEstate';
import GamesHub from './pages/GamesHub/GamesHub';
import Game2048 from './pages/Game2048/Game2048';
import Puzzle15 from './pages/Puzzle15/Puzzle15';
import MemoryGame from './pages/MemoryGame/MemoryGame';
import SnakeGame from './pages/SnakeGame/SnakeGame';
import WordleGame from './pages/WordleGame/WordleGame';
import TicTacToe from './pages/TicTacToe/TicTacToe';
import CarGame from './pages/CarGame/CarGame';
import './App.css';

function AppContent() {
  const { setTheme } = useTheme();

  useEffect(() => {
    setTheme('dark');
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/demo/task-manager" element={<TaskManager />} />
        <Route path="/demo/chat" element={<ChatApp />} />
        <Route path="/demo/weather" element={<Weather />} />
        <Route path="/demo/ecommerce" element={<Ecommerce />} />
        <Route path="/demo/analytics" element={<Analytics />} />
        <Route path="/demo/social-feed" element={<SocialFeed />} />
        <Route path="/demo/ai-dashboard" element={<AIDashboard />} />
        <Route path="/demo/real-estate" element={<RealEstate />} />
        <Route path="/demo/games" element={<GamesHub />} />
        <Route path="/demo/2048" element={<Game2048 />} />
        <Route path="/demo/puzzle" element={<Puzzle15 />} />
        <Route path="/demo/memory" element={<MemoryGame />} />
        <Route path="/demo/snake" element={<SnakeGame />} />
        <Route path="/demo/wordle" element={<WordleGame />} />
        <Route path="/demo/tictactoe" element={<TicTacToe />} />
        <Route path="/demo/car-race" element={<CarGame />} />
        <Route path="/demo/*" element={<ComingSoon />} />
      </Routes>
    </Router>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  );
}

export default App;
